import { uuidv4 } from '../helpers/utils';
import { SetFilters } from '../models/common.model';
import { CumulioDashboard } from '../models/dashboard.model';
import { FilterInput } from '../models/filters.model';

export const setFilters = <T extends CumulioDashboard>(
    dashboardComponent: T,
    iframe: HTMLIFrameElement,
    itemId: string,
    filters: FilterInput
  ): Promise<SetFilters> => {
    if (iframe) {
      const requestId = uuidv4();

      iframe.contentWindow.postMessage(
        {
          action: 'setFilters',
          itemId,
          filters,
          _version: dashboardComponent.VERSION,
          requestId
        },
        '*'
      );

      return new Promise((resolve, reject) => {
        dashboardComponent.promises[requestId] = { resolve, reject };
        // Check if promise has been resolved after 2 seconds
        setTimeout(() => {
          if (dashboardComponent.promises[requestId]) {
            const errorMessage = 'setFilters request timed out.';

            dashboardComponent.promises[requestId].reject(
              new Error(errorMessage)
            );
            delete dashboardComponent.promises[requestId];
          }
        }, 2000);
      });
    }

    return Promise.reject();
  };
